import React from "react";
import "./SettingsPanel.css";

/**
 * The body of the "Settings" right-column section. A list of labeled toggles
 * controlling per-user chat behavior. Settings here apply to NEW chats — an
 * agent's tool-permission policy is fixed when a thread is created.
 */
export default function SettingsPanel({ requireApproval, onRequireApprovalChange }) {
  return (
    <div className="ca-settings">
      <ToggleRow
        label="Require approval before running tools"
        hint="New chats pause for an allow/deny on each tool use."
        checked={requireApproval}
        onChange={onRequireApprovalChange}
      />
    </div>
  );
}

function ToggleRow({ label, hint, checked, onChange }) {
  return (
    <label className="ca-setting-row">
      <span className="ca-setting-text">
        <span className="ca-setting-label">{label}</span>
        {hint && <span className="ca-setting-hint">{hint}</span>}
      </span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        className={`ca-switch${checked ? " on" : ""}`}
        onClick={() => onChange(!checked)}
      >
        <span className="ca-switch-knob" />
      </button>
    </label>
  );
}
